module.exports = __webpack_public_path__ + "img/ssyx_19.bc75aed4.jpg";